import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import { en } from '../locales/en';
import { ru } from '../locales/ru';
import { ApiError } from './api';

const stored = (() => {
  try {
    return localStorage.getItem('aurea-lang');
  } catch {
    return null;
  }
})();

i18n.use(initReactI18next).init({
  resources: { ru: { translation: ru }, en: { translation: en } },
  lng: stored ?? 'ru',
  fallbackLng: 'ru',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLanguage(lng: 'ru' | 'en') {
  i18n.changeLanguage(lng);
  document.documentElement.lang = lng;
  try {
    localStorage.setItem('aurea-lang', lng);
  } catch {}
}

/** Текст ошибки API на языке пользователя. */
export function useErrorText() {
  const { t } = useTranslation();
  return (e: unknown) => {
    if (e instanceof ApiError)
      return t(`errors.${e.code}`, { ...(e.details ?? {}), defaultValue: e.message });
    return t('errors.INTERNAL');
  };
}

export default i18n;
